import React, { useState, useEffect } from "react";

// --- SVG Icon Components ---
const ScheduleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const DownloadIcon = ({ size = 14 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const TrendIcon = ({ size = 14, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);

const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#3B82F6"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const UsersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const ActivityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
  </svg>
);

const MessageSquareIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const ArrowLeftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="19" y1="12" x2="5" y2="12"></line>
    <polyline points="12 19 5 12 12 5"></polyline>
  </svg>
);

const LoadingSpinner = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="animate-spin"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
  </svg>
);

const LoginIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
    <polyline points="10 17 15 12 10 7"></polyline>
    <line x1="15" y1="12" x2="3" y2="12"></line>
  </svg>
);

const LockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#9CA3AF"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </svg>
);

const FullReportAccess = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reportsData, setReportsData] = useState({
    membership: null,
    geographic: null,
    engagement: null,
    registrationTrends: null,
    adminPerformance: null
  });
  const [reportErrors, setReportErrors] = useState({});
  const [activeModal, setActiveModal] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Function to get token from all possible storage locations
  const getAuthToken = () => {
    // Check all possible token names in localStorage
    const possibleTokenNames = [
      "token",
      "authToken",
      "access_token",
      "accessToken",
      "jwt",
      "jwtToken",
      "tinubu_token",
      "admin_token"
    ];
    
    for (const tokenName of possibleTokenNames) {
      const token = localStorage.getItem(tokenName);
      if (token) {
        return token;
      }
    }
    
    // Check sessionStorage
    for (const tokenName of possibleTokenNames) {
      const token = sessionStorage.getItem(tokenName);
      if (token) {
        return token;
      }
    }
    
    return null;
  };

  // Fetch all reports data
  useEffect(() => {
    const fetchAllReports = async () => {
      try {
        setLoading(true);
        setError(null);
        setReportErrors({});

        const token = getAuthToken();
        
        if (!token) {
          // No token found, show login message
          console.log("No authentication token found. Please login.");
          setError("Please login to access analytics reports");
          setIsDemoMode(true);
          setLoading(false);
          return;
        }

        console.log("Using token for API requests");
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 
                          process.env.REACT_APP_API_URL || 
                          "https://api.tinubu-ambode.org";
        
        // Define all endpoints
        const endpoints = [
          { key: 'membership', url: `${apiBaseUrl}/api/v1/analytics/reports/membership` },
          { key: 'geographic', url: `${apiBaseUrl}/api/v1/analytics/reports/geographic` },
          { key: 'engagement', url: `${apiBaseUrl}/api/v1/analytics/reports/engagement` },
          { key: 'registrationTrends', url: `${apiBaseUrl}/api/v1/analytics/reports/registration-trends` },
          { key: 'adminPerformance', url: `${apiBaseUrl}/api/v1/analytics/reports/admin-performance` }
        ];

        const headers = {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // Fetch all reports individually so one failure doesn't break all
        const newData = {};
        const errors = {};

        for (const endpoint of endpoints) {
          try {
            const response = await fetch(endpoint.url, { headers });
            
            if (!response.ok) {
              // Handle 403 specifically
              if (response.status === 403) {
                errors[endpoint.key] = "You don't have permission to access this report";
                newData[endpoint.key] = null;
                console.warn(`Permission denied for ${endpoint.key} report`);
              } else {
                throw new Error(`HTTP ${response.status} for ${endpoint.key}`);
              }
              continue;
            }
            
            const result = await response.json();
            
            if (result.success) {
              newData[endpoint.key] = result.data;
            } else {
              console.warn(`Failed to fetch ${endpoint.key} report:`, result.message);
              newData[endpoint.key] = null;
              errors[endpoint.key] = result.message || "Failed to load report";
            }
          } catch (err) {
            console.error(`Error fetching ${endpoint.key} report:`, err);
            newData[endpoint.key] = null;
            errors[endpoint.key] = err.message || "Failed to load report";
          }
        }

        setReportsData(newData);
        setReportErrors(errors);
        
        // Check if we have at least some data
        const hasSomeData = Object.values(newData).some(value => value !== null);
        if (!hasSomeData) {
          setError("Unable to load any reports. Please check your permissions.");
        }
        
        setIsDemoMode(false);
      } catch (err) {
        console.error("Error in fetchAllReports:", err);
        setError("Failed to load reports. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllReports();
  }, []);

  const openModal = (modalType, data) => {
    if (!data) {
      setError(`${modalType} report data not available`);
      return;
    }
    setActiveModal(modalType);
    setModalData(data);
  };

  const closeModal = () => {
    setActiveModal(null);
    setModalData(null);
  };

  const formatNumber = (num) => {
    if (num === undefined || num === null) return "0";
    return num.toLocaleString();
  };

  const formatPercentage = (num) => {
    if (num === undefined || num === null) return "0%";
    return `${num.toFixed(1)}%`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Calculate stats from fetched data
  const calculateStats = () => {
    const membershipData = reportsData.membership;
    const engagementData = reportsData.engagement;
    const trendsData = reportsData.registrationTrends;
    const adminData = reportsData.adminPerformance;
    const geographicData = reportsData.geographic;

    // Get total members from geographic data if membership data is not available
    let totalMembers = membershipData?.summary?.total_members || 0;
    if (totalMembers === 0 && geographicData?.geographic_distribution?.total_members) {
      totalMembers = geographicData.geographic_distribution.total_members;
    }

    return {
      totalMembers: totalMembers,
      totalReports: Object.values(reportsData).filter(data => data !== null).length,
      totalAdmins: adminData?.summary?.total_admins || 0,
      totalAnnouncements: engagementData?.summary?.announcements?.total_created || 0,
      totalRegistrations: trendsData?.summary?.total_registrations || 0,
      approvalRate: membershipData?.summary?.approval_rate || 0
    };
  };

  const stats = calculateStats();

  // Define reports with actual data
  const reports = [
    {
      title: "Member Analytics Report",
      desc: "Comprehensive member growth and engagement metrics",
      type: "membership",
      data: reportsData.membership,
      error: reportErrors.membership,
      lastGenerated: reportsData.membership?.metadata?.generated_at,
      requiredRole: "admin"
    },
    {
      title: "Geographic Distribution Report",
      desc: "Performance metrics across all states and regions",
      type: "geographic",
      data: reportsData.geographic,
      error: reportErrors.geographic,
      lastGenerated: reportsData.geographic?.metadata?.generated_at,
      requiredRole: "admin"
    },
    {
      title: "Engagement Analytics Report",
      desc: "Broadcast messages and engagement analytics",
      type: "engagement",
      data: reportsData.engagement,
      error: reportErrors.engagement,
      lastGenerated: reportsData.engagement?.metadata?.generated_at,
      requiredRole: "admin"
    },
    {
      title: "Registration Trends Report",
      desc: "Member registration patterns and growth trends",
      type: "registrationTrends",
      data: reportsData.registrationTrends,
      error: reportErrors.registrationTrends,
      lastGenerated: reportsData.registrationTrends?.metadata?.generated_at,
      requiredRole: "admin"
    },
    {
      title: "Admin Performance Report",
      desc: "Administrator actions and system usage statistics",
      type: "adminPerformance",
      data: reportsData.adminPerformance,
      error: reportErrors.adminPerformance,
      lastGenerated: reportsData.adminPerformance?.metadata?.generated_at,
      requiredRole: "super_admin"
    }
  ];

  const trends = [
    {
      name: "Member Growth",
      change: `${formatNumber(stats.totalMembers)} members`,
      color: "#10B981",
      icon: <UsersIcon />,
      available: stats.totalMembers > 0
    },
    {
      name: "Admin Activity",
      change: `${formatNumber(stats.totalAdmins)} admins`,
      color: "#3B82F6",
      icon: <ActivityIcon />,
      available: stats.totalAdmins > 0
    },
    {
      name: "Message Engagement",
      change: `${formatNumber(reportsData.engagement?.summary?.messages?.total_messages || 0)} messages`,
      color: "#8B5CF6",
      icon: <MessageSquareIcon />,
      available: reportsData.engagement?.summary?.messages?.total_messages > 0
    },
    {
      name: "Announcement Reach",
      change: `${formatNumber(reportsData.engagement?.summary?.announcements?.total_recipients || 0)} recipients`,
      color: "#F59E0B",
      icon: <DownloadIcon size={20} />,
      available: reportsData.engagement?.summary?.announcements?.total_recipients > 0
    }
  ];

  // Get geographic distribution data from the correct structure
  const getGeographicDistribution = () => {
    return reportsData.geographic?.geographic_distribution?.distribution || [];
  };

  // Check if user has any data
  const hasAnyData = Object.values(reportsData).some(value => value !== null);

  // Modal components - Right side modal
  const renderModal = () => {
    if (!activeModal || !modalData) return null;

    const modalStyles = {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        zIndex: 1000
      },
      content: {
        backgroundColor: 'white',
        width: '500px',
        maxWidth: '90vw',
        height: '100vh',
        overflowY: 'auto',
        position: 'relative',
        boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.1)',
        animation: 'slideIn 0.3s ease-out'
      },
      header: {
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? '16px' : '0',
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '1px solid #E5E7EB',
        position: 'sticky',
        top: 0,
        backgroundColor: 'white',
        zIndex: 10,
        padding: '24px 24px 16px 24px'
      },
      backButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        color: '#6B7280',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        flexShrink: 0
      },
      headerContent: {
        flex: 1
      },
      contentArea: {
        padding: '0 24px 24px 24px'
      }
    };

    const modalTitles = {
      membership: "Member Analytics",
      geographic: "Geographic Distribution",
      engagement: "Engagement Analytics",
      registrationTrends: "Registration Trends",
      adminPerformance: "Admin Performance"
    };

    return (
      <div style={modalStyles.overlay} onClick={closeModal}>
        <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
          <div style={modalStyles.header}>
            {isMobile && (
              <button 
                style={modalStyles.backButton} 
                onClick={closeModal}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#F3F4F6';
                  e.currentTarget.style.transform = 'translateX(-2px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
                aria-label="Go back"
              >
                <ArrowLeftIcon />
              </button>
            )}
            <div style={modalStyles.headerContent}>
              <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#111827' }}>
                {modalTitles[activeModal]} Report
              </h2>
              {isDemoMode && (
                <div style={{ fontSize: '12px', color: '#F59E0B', marginTop: '4px' }}>
                  Demo Data • View only
                </div>
              )}
            </div>
          </div>
          <div style={modalStyles.contentArea}>
            {activeModal === 'membership' && modalData && (
              <div>
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                    Summary
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                    <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                      <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Total Members</p>
                      <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                        {formatNumber(modalData.summary?.total_members)}
                      </p>
                    </div>
                    <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                      <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Approval Rate</p>
                      <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#10B981', margin: 0 }}>
                        {formatPercentage(modalData.summary?.approval_rate)}
                      </p>
                    </div>
                  </div>
                </div>

                {modalData.summary?.by_status && Object.keys(modalData.summary.by_status).length > 0 && (
                  <div style={{ marginBottom: '24px' }}>
                    <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                      Member Status
                    </h3>
                    <div style={{ backgroundColor: '#F9FAFB', borderRadius: '8px', padding: '16px' }}>
                      {Object.entries(modalData.summary.by_status).map(([status, count]) => (
                        <div key={status} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #E5E7EB' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{
                              width: '8px',
                              height: '8px',
                              borderRadius: '50%',
                              backgroundColor: 
                                status === 'approved' ? '#10B981' :
                                status === 'pending' ? '#F59E0B' :
                                status === 'suspended' ? '#EF4444' : '#6B7280'
                            }}></div>
                            <span style={{ textTransform: 'capitalize' }}>{status}</span>
                          </div>
                          <span style={{ fontWeight: '600' }}>{formatNumber(count)}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {modalData.summary?.by_category && Object.keys(modalData.summary.by_category).length > 0 && (
                  <div style={{ marginBottom: '24px' }}>
                    <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                      Member Categories
                    </h3>
                    <div style={{ backgroundColor: '#F9FAFB', borderRadius: '8px', padding: '16px' }}>
                      {Object.entries(modalData.summary.by_category).map(([category, count]) => (
                        <div key={category} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #E5E7EB' }}>
                          <span>{category}</span>
                          <span style={{ fontWeight: '600', color: '#3B82F6' }}>{formatNumber(count)}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeModal === 'geographic' && modalData && modalData.geographic_distribution && (
              <div>
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                    Geographic Distribution
                  </h3>
                  <div style={{ marginBottom: '16px', padding: '16px', backgroundColor: '#F9FAFB', borderRadius: '8px' }}>
                    <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Total Members Across Regions</p>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                      {formatNumber(modalData.geographic_distribution.total_members)}
                    </p>
                    <p style={{ fontSize: '12px', color: '#6B7280', marginTop: '8px' }}>
                      Level: {modalData.geographic_distribution.level}
                    </p>
                  </div>
                  <div style={{ backgroundColor: '#F9FAFB', borderRadius: '8px', padding: '16px' }}>
                    {modalData.geographic_distribution.distribution?.map((item, index) => (
                      <div key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #E5E7EB' }}>
                        <div>
                          <div style={{ fontWeight: '600' }}>{item.name}</div>
                          <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>{item.code}</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <span style={{ fontWeight: '600', color: '#3B82F6' }}>{formatNumber(item.count)}</span>
                          <span style={{ fontSize: '12px', color: '#10B981', fontWeight: '500' }}>
                            {formatPercentage(item.percentage)}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeModal === 'engagement' && modalData && (
              <div>
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                    Engagement Summary
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '12px', marginBottom: '24px' }}>
                    <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                      <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Announcements Created</p>
                      <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                        {formatNumber(modalData.summary?.announcements?.total_created)}
                      </p>
                    </div>
                    <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                      <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Total Messages</p>
                      <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                        {formatNumber(modalData.summary?.messages?.total_messages)}
                      </p>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                        <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Delivery Rate</p>
                        <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#10B981', margin: 0 }}>
                          {formatPercentage(modalData.summary?.announcements?.delivery_rate)}
                        </p>
                      </div>
                      <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                        <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Read Rate</p>
                        <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#3B82F6', margin: 0 }}>
                          {formatPercentage(modalData.summary?.announcements?.read_rate)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {modalData.announcement_effectiveness?.announcements && modalData.announcement_effectiveness.announcements.length > 0 && (
                  <div style={{ marginBottom: '24px' }}>
                    <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                      Recent Announcements
                    </h3>
                    <div style={{ backgroundColor: '#F9FAFB', borderRadius: '8px', padding: '16px', maxHeight: '300px', overflowY: 'auto' }}>
                      {modalData.announcement_effectiveness.announcements.slice(0, 5).map((announcement, index) => (
                        <div key={index} style={{ padding: '12px 0', borderBottom: '1px solid #E5E7EB' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                            <div style={{ fontWeight: '600', fontSize: '14px' }}>{announcement.title}</div>
                            <span style={{ fontSize: '12px', color: '#6B7280' }}>{formatDate(announcement.created_at)}</span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#6B7280' }}>
                            <span>Read: {formatPercentage(announcement.read_rate)}</span>
                            <span>{formatNumber(announcement.read_count)}/{formatNumber(announcement.total_recipients)}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeModal === 'registrationTrends' && modalData && (
              <div>
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                    Registration Trends
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                    <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                      <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Total Registrations</p>
                      <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                        {formatNumber(modalData.summary?.total_registrations)}
                      </p>
                    </div>
                    <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                      <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Approval Rate</p>
                      <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#10B981', margin: 0 }}>
                        {formatPercentage(modalData.summary?.approval_rate)}
                      </p>
                    </div>
                  </div>
                </div>

                {modalData.trends?.trends && modalData.trends.trends.length > 0 && (
                  <div>
                    <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                      Recent Registrations
                    </h3>
                    <div style={{ backgroundColor: '#F9FAFB', borderRadius: '8px', padding: '16px', maxHeight: '300px', overflowY: 'auto' }}>
                      {modalData.trends.trends.slice(-10).reverse().map((trend, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #E5E7EB' }}>
                          <span style={{ fontSize: '14px' }}>{formatDate(trend.period)}</span>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontWeight: '600', color: '#3B82F6' }}>{formatNumber(trend.count)}</span>
                            <span style={{ fontSize: '12px', color: '#6B7280' }}>registrations</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeModal === 'adminPerformance' && modalData && (
              <div>
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                    Administrator Performance
                  </h3>
                  <div style={{ backgroundColor: '#F9FAFB', padding: '16px', borderRadius: '8px', marginBottom: '24px' }}>
                    <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>Total Administrators</p>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                      {formatNumber(modalData.summary?.total_admins)}
                    </p>
                  </div>
                </div>

                {modalData.admin_performance && modalData.admin_performance.length > 0 && (
                  <div>
                    <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
                      Top Performers
                    </h3>
                    <div style={{ backgroundColor: '#F9FAFB', borderRadius: '8px', padding: '16px', maxHeight: '400px', overflowY: 'auto' }}>
                      {modalData.admin_performance.slice(0, 5).map((admin, index) => (
                        <div key={index} style={{ padding: '16px 0', borderBottom: '1px solid #E5E7EB' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '14px' }}>{admin.admin_name}</div>
                              <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>
                                {admin.admin_role.replace('-', ' ')}
                              </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ fontWeight: '600', color: '#3B82F6', fontSize: '16px' }}>
                                {formatNumber(admin.metrics.announcements_created)}
                              </div>
                              <div style={{ fontSize: '12px', color: '#6B7280' }}>announcements</div>
                            </div>
                          </div>
                          <div style={{ fontSize: '12px', color: '#6B7280' }}>
                            {admin.jurisdiction.description || admin.jurisdiction.level} • {formatNumber(admin.metrics.members_in_jurisdiction)} members
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const handleLogin = () => {
    window.location.href = "/login";
  };

  if (loading) {
    return (
      <div style={styles.page}>
        <div style={styles.container}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px', flexDirection: 'column', gap: '16px' }}>
            <LoadingSpinner />
            <span style={{ color: '#6B7280' }}>Loading reports...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {activeModal && renderModal()}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes slideIn {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
        .reports-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }
        .performance-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 32px;
          margin-top: 48px;
        }
        @media (max-width: 1024px) {
          .reports-grid { grid-template-columns: 1fr; }
          .performance-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 768px) {
          .stats-container { flex-direction: column; }
          .header { flex-direction: column; gap: 16px; }
        }
      `}</style>
      <div style={styles.page}>
        <div style={styles.container}>
          {/* Header */}
          <header style={styles.header} className="header">
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                <div style={styles.logoBadge}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#2563EB">
                    <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                  </svg>
                </div>
                <h1 style={styles.h1}>Analytics Reports Dashboard</h1>
              </div>
              <p style={styles.subtitle}>
                Access comprehensive analytics reports for informed decision-making
                {isDemoMode && (
                  <span style={{ color: '#F59E0B', marginLeft: '8px', fontWeight: '500', animation: 'fadeIn 0.3s ease' }}>
                    • Please login to access data
                  </span>
                )}
              </p>
            </div>
            {isDemoMode && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={styles.demoAlert}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#F59E0B" style={{ flexShrink: 0 }}>
                    <path d="M12 2L3 20h18L12 2zm0 4l6 12H6l6-12zM12 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-6v4"/>
                  </svg>
                  <span style={{ fontSize: '14px', color: '#92400E' }}>Login required</span>
                </div>
                <button 
                  style={styles.loginButton}
                  onClick={handleLogin}
                >
                  <LoginIcon />
                  Login for Data
                </button>
              </div>
            )}
          </header>

          {error && !isDemoMode && (
            <div style={styles.alert}>
              <span>{error}</span>
            </div>
          )}

          {/* Only show content if we have data */}
          {!isDemoMode && hasAnyData && (
            <>
              {/* Stats */}
              <div style={styles.statsContainer} className="stats-container">
                <div style={styles.statCard}>
                  <div style={{ ...styles.statIcon, backgroundColor: '#F0F9FF' }}>
                    <UsersIcon />
                  </div>
                  <p style={styles.statValue}>{formatNumber(stats.totalMembers)}</p>
                  <p style={styles.statLabel}>Total Members</p>
                  <div style={styles.statProgress}>
                    <div style={styles.progressBar}>
                      <div style={{ ...styles.progressFill, width: `${Math.min(stats.approvalRate, 100)}%` }}></div>
                    </div>
                    <span style={styles.statChange}>{formatPercentage(stats.approvalRate)} approval rate</span>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={{ ...styles.statIcon, backgroundColor: '#FEF7CD' }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="16" y1="13" x2="8" y2="13"></line>
                      <line x1="16" y1="17" x2="8" y2="17"></line>
                      <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                  </div>
                  <p style={styles.statValue}>{formatNumber(stats.totalReports)}</p>
                  <p style={styles.statLabel}>Available Reports</p>
                  <p style={{ ...styles.statChange, color: '#10B981' }}>
                    {stats.totalReports} of 5 accessible
                  </p>
                </div>
                <div style={styles.statCard}>
                  <div style={{ ...styles.statIcon, backgroundColor: '#F0FDF4' }}>
                    <ActivityIcon />
                  </div>
                  <p style={styles.statValue}>{formatNumber(stats.totalAdmins)}</p>
                  <p style={styles.statLabel}>Administrators</p>
                  <p style={styles.statChange}>
                    {stats.totalAdmins > 0 ? 'Active system users' : 'No admin data available'}
                  </p>
                </div>
              </div>

              {/* Available Reports */}
              <section style={{ marginTop: "48px", animation: 'fadeIn 0.5s ease' }}>
                <div style={styles.sectionHeader}>
                  <div style={{ ...styles.sectionIcon, backgroundColor: '#EFF6FF' }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="16" y1="13" x2="8" y2="13"></line>
                      <line x1="16" y1="17" x2="8" y2="17"></line>
                    </svg>
                  </div>
                  <div>
                    <h2 style={styles.h2}>Available Reports</h2>
                    <p style={styles.sectionSubtitle}>Select a report to view detailed analytics</p>
                  </div>
                </div>
                <div className="reports-grid">
                  {reports.map((report, index) => (
                    <div key={index} style={styles.reportCard}>
                      <div style={styles.reportCardHeader}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                          <div style={{ 
                            backgroundColor: report.type === 'membership' ? '#EFF6FF' : 
                                         report.type === 'geographic' ? '#F0F9FF' : 
                                         report.type === 'engagement' ? '#FEF7CD' : 
                                         report.type === 'registrationTrends' ? '#F0FDF4' : '#F5F3FF',
                            padding: '8px',
                            borderRadius: '8px',
                            opacity: report.data ? 1 : 0.5
                          }}>
                            {report.type === 'membership' && <UsersIcon />}
                            {report.type === 'geographic' && <LocationIcon />}
                            {report.type === 'engagement' && <MessageSquareIcon />}
                            {report.type === 'registrationTrends' && <TrendIcon size={16} stroke="#10B981" />}
                            {report.type === 'adminPerformance' && <ActivityIcon />}
                          </div>
                          <div>
                            <h3 style={styles.reportTitle}>{report.title}</h3>
                            <p style={styles.reportDesc}>{report.desc}</p>
                            <div style={styles.reportMetadata}>
                              {report.data ? (
                                <span style={{ fontSize: '12px', color: '#6B7280' }}>
                                  Updated: {formatDateTime(report.lastGenerated)}
                                </span>
                              ) : (
                                <span style={{ fontSize: '12px', color: '#9CA3AF', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  <LockIcon />
                                  {report.error || 'Requires higher permissions'}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        {report.data ? (
                          <span style={styles.liveBadge}>
                            LIVE
                          </span>
                        ) : (
                          <span style={{ ...styles.liveBadge, backgroundColor: '#F3F4F6', color: '#9CA3AF', borderColor: '#E5E7EB' }}>
                            LOCKED
                          </span>
                        )}
                      </div>
                      <div style={styles.reportCardFooter}>
                        <button 
                          style={{
                            ...styles.viewReportButton,
                            opacity: report.data ? 1 : 0.5,
                            cursor: report.data ? 'pointer' : 'not-allowed'
                          }}
                          onClick={() => report.data && openModal(report.type, report.data)}
                          disabled={!report.data}
                        >
                          <EyeIcon />
                          View Details
                        </button>
                        <button 
                          style={{
                            ...styles.downloadButton,
                            opacity: report.data ? 1 : 0.5,
                            cursor: report.data ? 'pointer' : 'not-allowed'
                          }}
                          disabled={!report.data}
                        >
                          <DownloadIcon />
                          Export Report
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {/* Performance Section */}
              <div className="performance-grid" style={{ animation: 'fadeIn 0.7s ease' }}>
                {/* Trends */}
                <section>
                  <div style={styles.sectionHeader}>
                    <div style={{ ...styles.sectionIcon, backgroundColor: '#FEF7CD' }}>
                      <TrendIcon size={20} stroke="#F59E0B" />
                    </div>
                    <div>
                      <h2 style={styles.h2}>Key Performance Metrics</h2>
                      <p style={styles.sectionSubtitle}>Real-time engagement and growth metrics</p>
                    </div>
                  </div>
                  <div style={styles.trendsContainer}>
                    {trends.filter(t => t.available).length > 0 ? (
                      trends.filter(t => t.available).map((trend, index) => (
                        <div key={index} style={styles.trendItem}>
                          <div style={styles.trendInfo}>
                            <div style={{...styles.trendIcon, color: trend.color, backgroundColor: `${trend.color}10`}}>
                              {trend.icon}
                            </div>
                            <div>
                              <p style={styles.trendName}>{trend.name}</p>
                              <span style={styles.trendSubtitle}>Current total</span>
                            </div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{
                              width: '8px',
                              height: '8px',
                              borderRadius: '50%',
                              backgroundColor: trend.color
                            }}></div>
                            <p style={{ ...styles.trendChange, color: trend.color }}>
                              {trend.change}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: '24px', textAlign: 'center', color: '#9CA3AF', backgroundColor: 'white', borderRadius: '12px', border: '1px solid #E5E7EB' }}>
                        No performance metrics available
                      </div>
                    )}
                  </div>
                </section>

                {/* Regional */}
                <section>
                  <div style={styles.sectionHeader}>
                    <div style={{ ...styles.sectionIcon, backgroundColor: '#EFF6FF' }}>
                      <LocationIcon />
                    </div>
                    <div>
                      <h2 style={styles.h2}>Geographic Overview</h2>
                      <p style={styles.sectionSubtitle}>Member distribution across regions</p>
                    </div>
                  </div>
                  <div style={styles.regionsContainer}>
                    {getGeographicDistribution().length > 0 ? (
                      getGeographicDistribution().map((region, index) => {
                        const totalMembers = reportsData.geographic?.geographic_distribution?.total_members || stats.totalMembers;
                        const percentage = totalMembers > 0 ? region.percentage || Math.round((region.count / totalMembers) * 100) : 0;
                        return (
                          <div key={index} style={styles.regionItem}>
                            <div style={styles.regionHeader}>
                              <div>
                                <p style={styles.regionName}>{region.name}</p>
                                <p style={styles.regionMembers}>{formatNumber(region.count)} members</p>
                              </div>
                              <p style={styles.performanceValue}>
                                {formatPercentage(percentage)}
                              </p>
                            </div>
                            <div style={styles.progressBarBg}>
                              <div
                                style={{
                                  ...styles.progressBarFg,
                                  width: `${percentage}%`,
                                  backgroundColor: ["#3B82F6", "#10B981", "#8B5CF6", "#F59E0B"][index % 4]
                                }}
                              ></div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div style={{ padding: '24px', textAlign: 'center', color: '#9CA3AF', backgroundColor: 'white', borderRadius: '12px', border: '1px solid #E5E7EB' }}>
                        Geographic data not available
                      </div>
                    )}
                  </div>
                </section>
              </div>
            </>
          )}

          {/* Show message if no data available */}
          {!isDemoMode && !hasAnyData && !loading && (
            <div style={{ textAlign: 'center', padding: '48px', backgroundColor: 'white', borderRadius: '16px', border: '1px solid #E5E7EB' }}>
              <LockIcon />
              <h3 style={{ marginTop: '16px', marginBottom: '8px', color: '#111827' }}>No Reports Available</h3>
              <p style={{ color: '#6B7280' }}>You don't have permission to access any reports. Please contact your administrator.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  page: {
    background: "linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)",
    padding: "24px",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
    minHeight: "100vh",
  },
  container: {
    maxWidth: "1280px",
    margin: "0 auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "32px",
    padding: "24px",
    backgroundColor: "white",
    borderRadius: "16px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",
    border: "1px solid #E5E7EB",
  },
  logoBadge: {
    backgroundColor: '#2563EB',
    color: 'white',
    width: '40px',
    height: '40px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  h1: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1F2937",
    margin: 0,
  },
  subtitle: {
    color: "#6B7280",
    fontSize: "16px",
    margin: "8px 0 0 0",
    lineHeight: 1.5,
  },
  demoAlert: {
    backgroundColor: '#FEF3C7',
    padding: '8px 12px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    border: '1px solid #FDE68A',
  },
  loginButton: {
    backgroundColor: "#10B981",
    color: "white",
    border: "none",
    borderRadius: "10px",
    padding: "12px 20px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 4px rgba(16, 185, 129, 0.2)",
  },
  alert: {
    backgroundColor: '#FEF3C7',
    border: '1px solid #F59E0B',
    color: '#92400E',
    padding: '12px 16px',
    borderRadius: '10px',
    marginBottom: '24px',
    fontSize: '14px',
  },
  statsContainer: {
    display: "flex",
    gap: "24px",
    marginBottom: "32px",
  },
  statCard: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid #E5E7EB",
    flex: 1,
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
  statIcon: {
    width: "56px",
    height: "56px",
    borderRadius: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
    color: "#3B82F6",
  },
  statValue: {
    fontSize: "32px",
    fontWeight: "bold",
    color: "#111827",
    margin: "0 0 4px 0",
  },
  statLabel: {
    fontSize: "14px",
    color: "#6B7280",
    margin: "0 0 12px 0",
  },
  statProgress: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  progressBar: {
    backgroundColor: '#F3F4F6',
    height: '6px',
    borderRadius: '9999px',
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#10B981',
    borderRadius: '9999px',
    transition: 'width 0.3s ease',
  },
  statChange: {
    fontSize: "13px",
    fontWeight: "500",
    color: "#10B981",
    margin: 0,
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "24px",
  },
  sectionIcon: {
    padding: '12px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  h2: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#111827",
    margin: 0,
  },
  sectionSubtitle: {
    fontSize: '14px',
    color: '#6B7280',
    margin: '4px 0 0 0',
  },
  reportCard: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid #E5E7EB",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
  reportCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
  },
  reportTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#111827",
    margin: "0 0 8px 0",
  },
  reportDesc: {
    fontSize: "14px",
    color: "#6B7280",
    margin: "0 0 12px 0",
    lineHeight: 1.5,
  },
  reportMetadata: {
    paddingTop: "12px",
    borderTop: "1px solid #F3F4F6",
  },
  liveBadge: {
    backgroundColor: "#DCFCE7",
    color: "#166534",
    padding: "6px 12px",
    borderRadius: "9999px",
    fontSize: "11px",
    fontWeight: "600",
    height: "fit-content",
    border: "1px solid #86EFAC",
  },
  reportCardFooter: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "12px",
    paddingTop: "16px",
    borderTop: "1px solid #F3F4F6",
  },
  viewReportButton: {
    backgroundColor: "transparent",
    color: "#6B7280",
    border: "1px solid #D1D5DB",
    borderRadius: "10px",
    padding: "10px 18px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    transition: "all 0.2s ease",
  },
  downloadButton: {
    backgroundColor: "#2563EB",
    color: "white",
    border: "none",
    borderRadius: "10px",
    padding: "10px 18px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 4px rgba(37, 99, 235, 0.2)",
  },
  trendsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  trendItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    backgroundColor: "white",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    transition: "transform 0.2s ease",
  },
  trendInfo: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  trendIcon: {
    backgroundColor: "#F3F4F6",
    padding: "12px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  trendName: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#111827",
    margin: 0,
  },
  trendSubtitle: {
    fontSize: "12px",
    color: "#6B7280",
    margin: "4px 0 0 0",
  },
  trendChange: {
    fontSize: "15px",
    fontWeight: "600",
    margin: 0,
  },
  regionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  regionItem: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    transition: "transform 0.2s ease",
  },
  regionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "12px",
  },
  regionName: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#111827",
    margin: 0,
  },
  regionMembers: {
    fontSize: "12px",
    color: "#6B7280",
    margin: "4px 0 0 0",
  },
  performanceValue: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#3B82F6",
    margin: 0,
  },
  progressBarBg: {
    backgroundColor: "#F3F4F6",
    height: "8px",
    borderRadius: "9999px",
    overflow: "hidden",
  },
  progressBarFg: {
    height: "100%",
    borderRadius: "9999px",
    transition: "width 0.3s ease",
  },
};

export default FullReportAccess;